import { useSelector } from "react-redux";
import Paywall from "./Paywall";
import Section from "./Section";

const DashboardRoot = ({ dashboard }) => {
    const hasAccess = useSelector(state => state.reader?.has_access);
    const gateType = dashboard?.gate_type;

    if (!hasAccess && gateType === 'hard') {
        return <Paywall paywallText={dashboard?.paywall_text} />
    }

    return <Section dashboard={dashboard} />
};

export default DashboardRoot;
